import { Injectable, Inject } from '@angular/core';
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Injectable()
export class SpecimensAndSamplesActionsService {

  constructor(private authService: AuthenticationService) {
  }
}
